import React from 'react';
import { t } from '@citrite/translate';
import { CitrixLogoIcon, layout, palette, typography } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { useFeatureCanary } from 'utils/useFeatureCanary';

const StyledMessageSpanLegacy = styled.span`
	font-size: ${typography.sizes.xsml};
	font-weight: ${typography.weights.regular};
	color: ${palette.grey900};
	padding: 4px 4px 0 0;
	height: ${layout.space12};
`;

const StyledMessageSpanDetailed = styled(StyledMessageSpanLegacy)`
	padding: 0 ${layout.space4} 0 0;
`;

export const CitrixBranding = () => {
	const isCenterAlignClassicViewEnabled = useFeatureCanary(
		FeatureFlag.CenterAlignClassicView
	);

	const StyledMessageSpan = isCenterAlignClassicViewEnabled
		? StyledMessageSpanDetailed
		: StyledMessageSpanLegacy;

	return (
		<div>
			<StyledMessageSpan>{`${t('Workspace:powered_by')}`}</StyledMessageSpan>
			<CitrixLogoIcon height={12} width={35} />
		</div>
	);
};
